import { MultiStrikeChartTypes } from '../../reducer/multiStrikeChart.reducer'

/** Migrate legacy oi + showChange configs to the dedicated oiChange type. */
export function normalizeMultiStrikeChartType(
    chartType: MultiStrikeChartTypes | undefined,
    showChange?: boolean
): MultiStrikeChartTypes {
    if (chartType === 'oi' && showChange) {
        return 'oiChange'
    }
    return chartType ?? 'iv'
}

export function isOiValueChartType(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'oiChange' || chartType === 'cumOi' || chartType === 'oiDiff'
}

export function isAbsoluteOiChartType(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'cumOi'
}

/** Straddle / OI Diff: one synthetic line per strike from CE+PE legs. */
export function isCombinedLegChartType(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'straddle' || chartType === 'oiDiff'
}

/** Cumulative toggle keeps chart type and aggregates across strikes (not `cumOi` type). */
export function usesCumulativeFlag(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'straddle' || chartType === 'oiDiff'
}

export function showsCumOiToggle(chartType: MultiStrikeChartTypes): boolean {
    return chartType === 'oi' || chartType === 'oiChange' || chartType === 'cumOi' || chartType === 'straddle' || chartType === 'oiDiff'
}

/** Map cumOi (+ change mode) to the chart-type menu value. */
export const getMultiStrikeChartTypeMenuValue = (
    chartType: MultiStrikeChartTypes,
    cumOi: boolean,
    showChange?: boolean
): 'price' | 'iv' | 'oi' | 'oiChange' | 'straddle' | 'oiDiff' => {
    if (chartType === 'cumOi') {
        return showChange ? 'oiChange' : 'oi'
    }
    if (chartType === 'oi' && cumOi) {
        return 'oi'
    }
    if (chartType === 'oiChange') {
        return 'oiChange'
    }
    return chartType as 'price' | 'iv' | 'oi' | 'oiChange' | 'straddle' | 'oiDiff'
}

export function resolveCumOiToggleState(
    checked: boolean,
    currentChartType: MultiStrikeChartTypes,
    showChange?: boolean
): { chartType: MultiStrikeChartTypes; cumOi: boolean; showChange: boolean } {
    if (usesCumulativeFlag(currentChartType)) {
        return { chartType: currentChartType, cumOi: checked, showChange: false }
    }
    if (checked) {
        const usesChange = currentChartType === 'oiChange' || (currentChartType === 'cumOi' && showChange)
        return {
            chartType: 'cumOi',
            cumOi: true,
            showChange: usesChange,
        }
    }
    const returnToOiChange = currentChartType === 'cumOi' && showChange
    return {
        chartType: returnToOiChange ? 'oiChange' : 'oi',
        cumOi: false,
        showChange: false,
    }
}
